import { createFileRoute } from '@tanstack/react-router'
import { ProjectEditor } from './-ProjectEditor'

// ModuleGuard komt van de projects-route.tsx layout — geen wikkel per pagina.
export const Route = createFileRoute('/projects/$id')({
  component: ProjectDetailPage,
})

function ProjectDetailPage() {
  const { id } = Route.useParams()
  return <ProjectEditor id={id} />
}
